import React, { useEffect, useState } from 'react';
import Config from './Config';
import ConversationInterface from './components/Experiment/Conversation/ConversationInterface';
import './Experiment.css';
import PromptEditor from './components/Experiment/Prompt/PromptEditor';
import ChainViewer from './components/Experiment/Observability/ChainViewer';
import SystemPromptEditor from './components/Experiment/Prompt/SystemPromptEditor';
import LLMResponseViewer from './components/Experiment/Observability/LLMResponseViewer';
import { Box, Divider, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography } from '@mui/material';
import ZipCodeInput from './components/ZipCodeInput/ZipCodeInput';


const Experiment = () => {

    const [prompt, setPrompt] = useState([]);
    const [chainOfThoughtReasoning, setChainOfThoughtReasoning] = useState('');
    const [llmResponse, setLLMResponse] = useState('');
    const [systemPrompt, setSystemPrompt] = useState('');
    const [zipCode, setZipCode] = useState('60692');
    const [searchText, setSearchText] = useState('');
    const [criteria, setCriteria] = useState('');
    
    const handleCriteriaChange = (criteria) => {
        setCriteria(criteria);
    };


    const handleSearchChange = (_event, value) => {
        setSearchText(value);
    };

    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="container" sx={{backgroundColor: 'lightgrey'}}>
            <Box
                sx={{
                height: '6px',
                background: 'linear-gradient(to right, #308BEE, #93F0BA)',
                }}
            />
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h4" style={{ fontWeight: 'bolder', marginRight: '10px' }}>Cars for Sale Near Me</Typography>
                <ZipCodeInput 
                    zipCode={zipCode} 
                    setZipCode={setZipCode}
                />
            </Box>
            <Box sx={{ backgroundColor: '#f3f3f3', padding:'20px'}}>
                <ConversationInterface 
                    config={Config} 
                    searchText={searchText} 
                    handleSearchChange={handleSearchChange} 
                    criteria={criteria} 
                    zipCode={zipCode}
                    handleCriteriaChange={handleCriteriaChange} 
                    setPrompt={setPrompt} 
                    setChainOfThoughtReasoning={setChainOfThoughtReasoning} 
                    setLLMResponse={setLLMResponse} />
            </Box>

            <Accordion sx={{
                    '&.MuiAccordion-root,&.Mui-expanded':{
                        marginTop: '0'
                    }
                }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                        backgroundColor: '#f3f3f3', 
                        borderBottom: '1px solid rgba(0, 0, 0, .12)',
                        padding: '20px', 
                        boxShadow: 4
                    }}
                >
                    <Typography>Model Observability</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: '20px'}}>
                    <Box sx={{
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        padding: '20px', 
                        boxShadow: 4 
                    }}>
                        <Box  sx={{flex: 1, padding: '20px', boxShadow: 4 }}>
                            <PromptEditor systemPrompt={systemPrompt} prompt={prompt} />
                        </Box>
                        <Box sx={{ flex: 1, padding: '20px', boxShadow: 4 }}>
                            <ChainViewer chainOfThoughtReasoning={chainOfThoughtReasoning} />
                        </Box>
                        <Box sx={{ flex:1, padding: '20px', boxShadow: 4 }}>
                            <LLMResponseViewer config={Config} searchText={searchText} handleSearchChange={handleSearchChange} criteria={criteria} handleCriteriaChange={handleCriteriaChange} llmResponse={llmResponse}/>
                        </Box>
                        <Divider sx={{boxShadow: 4}} />
                    </Box>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                        backgroundColor: '#f3f3f3', 
                        borderBottom: '1px solid rgba(0, 0, 0, .12)', 
                        boxShadow: 4
                    }}
                >
                    <Typography>System Prompt</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: '20px'}}>
                    <Box sx={{ backgroundColor: '#f3f3f3', padding:'20px'}}>
                        <SystemPromptEditor config={Config} systemPrompt={systemPrompt} setSystemPrompt={setSystemPrompt} />
                    </Box>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}

export default Experiment;
